import * as React from 'react';
import * as classNames from 'classnames';
import track from 'react-tracking';
import { TrackingProps } from '@reverbdotcom/commons/dist/tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { experiments } from '../shared/constants';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { useViewTracking } from '@reverbdotcom/commons/dist/use_tracking';

interface IProps extends IUserContext, TrackingProps {
  title: string;
  subtitle?: string | JSX.Element;
  linkUrl?: string;
  linkText?: string;
  linkTarget?: string;
  subclass?: string;
  shouldTrack?: boolean;
}

const COMPONENT_NAME = 'ListingNudge';

export function ListingNudge(props: IProps) {
  const classes = classNames(
    'listing-nudge',
    props.subclass,
  );

  const mParticleViewData = {
    eventName: MParticleEventName.ComponentView,
    componentName: COMPONENT_NAME,
    experiments: formatExperimentsForEventAttributes(props.user, [
      experiments.REVERB_PROTECTION_CART,
    ]),
  };

  useViewTracking(mParticleViewData, props.shouldTrack);

  return (
    <div className={classes}>
      <div className="listing-nudge__icon" />
      <div className="listing-nudge__inner">
        <p className="listing-nudge__title" data-nudge-title>
          {props.title}
        </p>
        {!!props.subtitle &&
          <p className="listing-nudge__subtitle" data-nudge-subtitle>
            {props.subtitle}
          </p>
        }
        {!!props.linkUrl && !!props.linkText &&
          <a
            className="weight-bold size-80"
            href={props.linkUrl}
            target={props.linkTarget}
            data-nudge-link
          >
            {props.linkText}
          </a>
        }
      </div>
    </div>
  );
}

export default track({ componentName: COMPONENT_NAME })(withUserContext(ListingNudge));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/listing_nudge.tsx